module.exports = __webpack_public_path__ + "assets/img/my-a.9fbe9dba.png";